import "./App.css";
import { TodoWrapper } from "./Todo/TodoWrapper";

function App() {
  return (
    <div className="App">
      <TodoWrapper />
    </div>
  );
}

export default App;
